import styled from "styled-components"
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import { useDispatch } from "react-redux";
import { newReventa } from "../redux/actions/reventaActions.js"

let Container=styled.div`

`;

export default function InputWithFlag(props){
	let {codFlag,label,pais,value}=props;
	let dispatch=useDispatch();

	let onChange=async(e)=>{
			let value=e.target.value;
			dispatch(newReventa({[`precio_${pais}`]:value}))
	}
	return(
		<Container>
			<FormControl variant="standard">
					<InputLabel htmlFor="input-with-icon-adornment">{label}</InputLabel>
        			<Input type="number" onChange={onChange} value={value} startAdornment={
            			<InputAdornment position="start">
               				<img loading="lazy" width="20" alt="flag"
               					srcSet={`https://flagcdn.com/w40/${codFlag}.png 2x`} 
               					src={`https://flagcdn.com/w20/${codFlag}.png`} 
               				/>
            			</InputAdornment>
          			}
        			/>
        	</FormControl >
        </Container>
		)
}